export default __webpack_public_path__ + "static/adianano-c2beefb95cf550e84d1d5cd5d7160058.png";